import { useMediaQuery } from 'hooks';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from 'redux/hooks/useAppSelector';
import { discountsSelectors } from 'redux/modules/Discounts';
import { calculateDeclinationResultTitle } from '../../utils/utils';

export const useInfoTitle = (isStartSearchTitleHidden: boolean) => {
  const { t } = useTranslation();

  const { mobile, tablet } = useMediaQuery();

  const isMobile = mobile || tablet;

  const searchResults = useAppSelector(discountsSelectors.getSearchResults);

  const startSearch = useMemo(
    () => ({
      titleHeader: '',
      description: t('search.enterName'),
    }),
    [t],
  );

  const foundItem = useMemo(
    () => ({
      titleHeader: '',
      description: `${calculateDeclinationResultTitle(
        searchResults?.totalElements,
      )}`,
    }),
    [searchResults],
  );

  const notFound = useMemo(
    () => ({
      titleHeader: isMobile
        ? t('search.noResultFoundForMobile')
        : t('search.noResultsFound'),
      description: isMobile ? '' : t('search.tryChangingTheRequest'),
    }),
    [isMobile, t],
  );

  if (searchResults) return !searchResults.totalElements ? notFound : foundItem;

  return isStartSearchTitleHidden ? notFound : startSearch;
};
